import { useEffect, useState } from 'react';

export const EndsInCountDownForDate = (props) => {

    let intervalId;

    const [countdown, setCountdown] = useState(null);

    useEffect(
      () => {
        const countDownDate = props.countDownDate;
        if (!countDownDate) {
            return null;
        }

        intervalId = setInterval(() => {

            // Get today's date and time
            const now = new Date().getTime();
          
            // Find the duration between now and the count down date
            let duration = countDownDate - now;

            if (duration < 0) {
              duration = 0;
            }

            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(duration / (1000 * 60 * 60 * 24));

            let countdownPhrase = "Ends in ";

            if (days === 1) {
              countdownPhrase += days + " day";
            } else {
              countdownPhrase += days + " days";
            }
            setCountdown(countdownPhrase);

          }, 1000);

        return () => {
          clearInterval(intervalId);
        }
      },
      [] // no state params, only running once
    );
    
    return (
        <>
            {countdown}
        </>
    )
}

export const ResetsInCountDownForDate = (props) => {

  let intervalId;

  const [countdown, setCountdown] = useState(null);

  useEffect(
    () => {
      const countDownDate = props.countDownDate;
      if (!countDownDate) {
          return null;
      }

      intervalId = setInterval(() => {

          // Get today's date and time
          const now = new Date().getTime();
        
          // Find the duration between now and the count down date
          let duration = countDownDate - now;
        
          if (duration < 0) {
            duration = 0;
          }

          // Time calculations for days, hours, minutes and seconds
          const days = Math.floor(duration / (1000 * 60 * 60 * 24));
          const hours = Math.floor((duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((duration % (1000 * 60)) / 1000);

          // "Resets in 32:16:11:23"
          let countdownPhrase = "Resets in ";

          if (days) {
              countdownPhrase += days + ":"
          }

          countdownPhrase += hours < 10 ? "0" + hours : hours;
          countdownPhrase += ":";
          countdownPhrase += minutes < 10 ? "0" + minutes : minutes;
          countdownPhrase += ":";
          countdownPhrase += seconds < 10 ? "0" + seconds : seconds;
          setCountdown(countdownPhrase);
      }, 1000);

      return () => {
        clearInterval(intervalId);
      }
    },
    [] // no state params, only running once
  );
  
  return (
      <>
          {countdown}
      </>
  )
}